import * as React from 'react';
import { basePageWrap } from '../BasePage';

import { Image } from '../../types';
import Streamfield from '../../components/Streamfield';
import HeroVideo from '../../components/HeroVideo';

import Preamble from '../../components/Preamble';

import s from './PageCaseEnhanced.module.scss';
import h from '../../components/HeroVideo/HeroVideo.module.scss';
import w from '../../components/Wysiwyg/Wysiwyg.module.scss';

interface PageCaseEnhancedProps {
    title: string;
    preamble: string;
    content: any[];
    featuredImageLarge: Image;
    heroBottomImage: Image;
    heroVideoUrl?: string;
    heroInfoBox?: string;
    heroInfoBoxUrl?: string;
    headlineThemeColor?: string;
    boxThemeColor?: string;
    scrollThemeColor?: string;
}

const PageCaseEnhanced: React.FC<PageCaseEnhancedProps> = ({
    title,
    preamble,
    content,
    featuredImageLarge,
    heroVideoUrl,
    heroBottomImage,
    heroInfoBox,
    heroInfoBoxUrl,
    headlineThemeColor,
    boxThemeColor,
    scrollThemeColor,
    ...props
}) => {
    React.useEffect(() => {
        if (!document || !window || !headlineThemeColor) {
            return
        }

        const pageEl = document.getElementById("PageCaseEnhanced")
        const elems = pageEl.querySelectorAll<HTMLElement>(`.${w.Root} h1, .${w.Root} h2, .${w.Root} h3, .${w.Root} h4, .${w.Root} h5, .${w.Root} h6`);

        for(let i = 0; i < elems.length; i++) {
            elems[i].style.color = headlineThemeColor;
        }

    }, [headlineThemeColor])

    React.useEffect(() => {
        if (!document || !window || !boxThemeColor) {
            return
        }

        const elems = document.querySelectorAll<HTMLElement>(`.${h.SiteLink}`);
        for(let i = 0; i < elems.length; i++) {
            elems[i].style.background = boxThemeColor;
        }

    }, [boxThemeColor])

    React.useEffect(() => {
        if (!document || !window || !scrollThemeColor) {
            return
        }

        const footerEl = document.getElementById('Footer');
        const heroEl = document.getElementById('HeroVideo');
        const changeHeight = heroEl.clientHeight - 200;

        const handleScroll = () => {
            const scrollTop = (window.pageYOffset !== undefined)
                ? window.pageYOffset
                : (
                    document.documentElement as HTMLElement ||
                    document.body.parentNode as HTMLElement ||
                    document.body as HTMLElement
                ).scrollTop
            const element = document.getElementById("PageCaseEnhanced") as HTMLElement;

            if(scrollTop >= changeHeight) {
                element.style.background = scrollThemeColor;
                footerEl.style.background = scrollThemeColor;
            } else {
                element.style.background = 'transparent';
                footerEl.style.background = 'transparent';
            }
        }

        window.addEventListener('scroll', handleScroll)
        return () => {
            window.removeEventListener('scroll', handleScroll)
        }
    }, [scrollThemeColor])

    return (
        <div id="PageCaseEnhanced" className={s.Root}>
            <HeroVideo
                title={title}
                featuredImage={featuredImageLarge}
                heroVideoUrl={heroVideoUrl}
                heroBottomImage={heroBottomImage}
                heroInfoBox={heroInfoBox}
                heroInfoBoxUrl={heroInfoBoxUrl}
            />
            <div className={s.Content}>
                <Preamble preamble={preamble} />
            </div>
            <div className={s.Streamfield}>
                <Streamfield items={content} />
            </div>
        </div>
    );
};

export default basePageWrap(PageCaseEnhanced);
